//libs
import { useState, useEffect } from 'react';

//types
import { IResizeEventTarget } from '../types/IResizeEventTarget';

export function useColumnResize() {
    const [columnCount, setColumnCount] = useState(4);

    useEffect(() => {
        const handleResize = (event?: Event) => {
            const target: IResizeEventTarget | null = event?.target ?? window;

            if(target?.outerWidth && target?.outerWidth <= 550){
                setColumnCount(1);
            } else if(target?.outerWidth && target?.outerWidth <= 750){
                setColumnCount(2);
            } else if(target?.outerWidth && target?.outerWidth <= 950){
                setColumnCount(3);
            } else {
                setColumnCount(4);
            }
        };

        handleResize();

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return [
        columnCount,
    ]
}